import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Form, Button } from 'react-bootstrap';
import { hideModal } from '../../../actions/modalsActions';
import { setActiveChannel } from '../../../actions/Dashboard/personalBoards/channelsActions';
import CyberSecurity from '../../../apis/cyberSecurityData';

//imported comps
import LabelsSelection from './LabelsSelection';
import AddPersonalChannel from '../../Pages/Dashboard/sections/PersonalBoard/Forms/AddPersonalChannel';
import addFilled from '@iconify-icons/carbon/add-filled';
import { Icon, InlineIcon } from '@iconify/react';
const AddDetails = ({ item }) => { //mode addItemFeed || addMessageFeed || editFeed

  //selecting data from redux store
  const currentUser = useSelector(state => state.currentUser);
  const accessToken = useSelector(state => state.accessToken);
  const channels = useSelector(state => state.personalBoard.channels);
  const dispatch = useDispatch();
  //comp local state
  const [selectedChannel, setSelectedChannel] = useState('');
  // const [selectedChannel, setSelectedChannel] = useState(channels && channels.length > 0 ? channels[0] : '');
  const [existItem, setExistItem] = useState({});
  const [selectedBoardLabels, setSelectedBoardlabels] = useState([]);
  const [selectedPersonalTags, setSelectedPersonallabels] = useState([]);
  //Form State
  const [noteDescription, setNoteDescription] = useState('');
  const [userInputNote, setUserInputNote] = useState('');
  const [userInputTags, setUserInputTags] = useState([]);
  const [formError, setFormError] = useState('');

  useEffect(() => {
    if (selectedChannel) getTags();
  }, [selectedChannel])

  const getTags = async () => {
    const response = await CyberSecurity.get(`/pboards/thread/channelitem?itemId=${item._id}&channelId=${selectedChannel._id}`, {
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    })

    if (response.data) {
      setExistItem(response.data);
      if (response.data.note) setNoteDescription(response.data.note);
      else {
        userInputNote ? setNoteDescription(userInputNote) : setNoteDescription('')
      }
      if (response.data.personalTags) setSelectedPersonallabels(response.data.personalTags);
      else {
        userInputTags.length > 0 ? setSelectedPersonallabels(userInputTags) : setSelectedPersonallabels([])
      }
    }

    // setSelectedPersonallabels(response.data)
  }

  const onFormSubmit = async () => {
    if (noteDescription.length > 1000) return setFormError('Note length must not exced 1000 characters');
    if (!selectedChannel) return setFormError('Please Select Channel');

    const regex = /^[ A-Za-z0-9_.&?!’:',-/()\n]*$/;
    const validatedNote = noteDescription.match(regex);

    if (!validatedNote) return setFormError('Please remove any special characters');

    setFormError('');

    //code here will run if the item is sent to this channel befor so will update the item
    if (existItem._id) {
      const updates = {
        _id: existItem._id,
        note: noteDescription,
        personalTags: selectedPersonalTags,
      }

      try {
        await CyberSecurity.patch('/pboards/threads', updates, {
          headers: {
            Authorization: 'Bearer ' + accessToken
          }
        })

        dispatch(setActiveChannel(selectedChannel));
        dispatch(hideModal());
      } catch (error) {
        setFormError('Something went wrong')
      }
    }


    //code here will run to create new item for the selected channel
    else {
      const record = {
        personalTags: selectedPersonalTags,
        channelId: selectedChannel._id,
        itemId: item._id,
        owner: currentUser._id,
        note: noteDescription,
      }

      try {
        await CyberSecurity.post('/pboards/threads', record, {
          headers: {
            Authorization: 'Bearer ' + accessToken
          }
        })

        dispatch(setActiveChannel(selectedChannel));
        dispatch(hideModal());
      } catch (error) {
        setFormError('Something went wrong')
      }
    }


  }

  return (
    <div>

      <div>
        <Row>
          <Col md={8} className="pr-md-4 pt-3">
            <label className="form-label label--uppercase">Send to</label>
            <span className="d-block form-info-text text-md">My personal board</span>

            {/* ---------- Item Details ---------------------*/}
            {item && <div className="shared-block">
              <Row>
                <Col md={8}>
                  <div>
                    <h3 className="mb-0 p-3">{item.title}</h3>
                  </div>
                </Col>

                <Col md={4}>
                  <img src={item.image} alt="" className="shared-block__img" />
                </Col>
              </Row>
            </div>}

            {/* ------------Note Input Form------------------- */}
            <Form.Group>
              <Form.Label className="label--uppercase">Detailed note</Form.Label>
              <Form.Control value={noteDescription}
                onChange={(e) => {
                  setNoteDescription(e.target.value);
                  setUserInputNote(e.target.value);
                }}
                as="textarea" rows="4" placeholder="Type your detailed note here (optional)" />
            </Form.Group>

            <p className="text-red">{formError}</p>

            <div className="d-flex justify-content-center py-4">
              <Button variant="primary" size="lg" className="w-100" onClick={onFormSubmit}>
                Send to my board
              </Button>
            </div>

          </Col>

          <Col className="px-md-4 modal-right-sidebar pt-4" md={4}>

            {/* -----------------Rendering Channels ------------------- */}
            <div className="mt-4">
              <div>
                <span className="mb-3 form-label label--uppercase d-block">Channels</span>
                <AddPersonalChannel trigger={<span className="add-tag-btn add-tag-btn--lg"><Icon icon={addFilled} className="mr-2"/> Add channel</span>} />
              </div>
              <ul className="channels-list">
                {channels && channels.length > 0 && channels.map(channel => {
                  return <li key={channel._id} className={selectedChannel._id === channel._id ? 'selected text-blue' : ''} onClick={() => setSelectedChannel(channel)}># {channel.name}</li>
                })}
              </ul>
            </div>


            {/* ----------------Personal Labels Section------------------------*/}
            <LabelsSelection
              selectedBoardLabels={selectedBoardLabels}
              setSelectedBoardlabels={setSelectedBoardlabels}
              selectedPersonalTags={selectedPersonalTags}
              setSelectedPersonallabels={setSelectedPersonallabels}
              userInputTags={userInputTags}
              setUserInputTags={setUserInputTags}
            />

          </Col >
        </Row>
      </div>
    </div>
  )
}

export default AddDetails
